
const VocabSexes = {
    'female' : ['Mujer', 'Female'],
    'male' : ['Hombre', 'Male'],
    'trans_female' : ['Mujer trans', 'Trans female'],
    'trans_male' : ['Hombre trans', 'Trans male'],
  }
  export default VocabSexes;
    